import { useEffect, useState } from "react";
import { StyledSettingsScreen } from "../../styled-cmps/settings-screen";
import CustomTable from "../common/CustomTable";
import { DataGridText, SettingsPageText } from "../../data/texts";
import { UserService } from "../../services/user.service";
import { Deal } from "../../models/user.models";
import { DateTimeService } from "../../services/date-time.service";
import { GridColDef } from "@mui/x-data-grid";
import { ProductName } from "../client-dashboard/product-request-table/ProductRequestTable";
import { Icons } from "../../models/assets-files";
import ProductCell from "../client-dashboard/product-request-table/ProductCell";
import { ImageService } from "../../services/image.service";
import DownloadForOfflineOutlinedIcon from "@mui/icons-material/DownloadForOfflineOutlined";
import { Box, CircularProgress, useTheme } from "@mui/material";

interface BillingTableRow {
  id: string;
  tool: string;
  date: string;
  invoice: string;
}

const BillingScreen = () => {
  const [isLoading, setIsLoading] = useState(true);
  const theme = useTheme();
  useEffect(() => {
    fetchBillings();
  }, []);

  const fetchBillings = async () => {
    const toolInfo = await UserService.getAllToolInfo();
    if (!toolInfo) return;
    const allDeals: Deal[] = [];
    toolInfo.forEach((tool: any) => {
      tool.deals.forEach((deal: any) => {
        allDeals.push({ ...deal, tool: tool.productRequestType });
      });
    });

    convertDataToTableRows(allDeals);
  };

  const convertDataToTableRows = (data: Deal[]) => {
    const rows = data.map((deal) => {
      return {
        id: deal.id,
        tool: deal.tool,
        date: DateTimeService.convertDateToDDMMYYYY(
          new Date(deal.Created_Time)
        ),
        invoice: deal.invoice,
      };
    });
    setTableRows(rows);
  };
  const onInvoiceOpen = (link: string) => {
    window.open(link, "_blank");
  };
  const [tableRows, setTableRows] = useState<BillingTableRow[]>();
  useEffect(() => {
    if (tableRows) {
      setIsLoading(false);
    }
  }, [tableRows]);
  const tableColumns: GridColDef[] = [
    {
      field: "id",
      headerName: "ID",
      flex: 1,
      minWidth: 200,
    },
    {
      minWidth: 300,
      field: "tool",
      headerName: "Tool",
      renderCell: (params) => {
        const productName = params.row.tool
          .toUpperCase()
          .replace(" ", "_") as ProductName;
        const iconSrcName = Icons.ProductRequestTable[productName];
        return (
          <ProductCell
            text={params.row.tool}
            iconSrc={
              iconSrcName
                ? ImageService.getLocalIconPath(
                    Icons.Folders.PRODUCT_REQUEST_TABLE,
                    iconSrcName
                  )
                : ""
            }
          />
        );
      },
      flex: 1,
    },
    {
      minWidth: 120,
      field: "date",
      headerName: "Date",
      flex: 1,
    },
    {
      minWidth: 300,
      field: "invoice",
      headerName: "Invoice",
      renderCell: (params) => (
        <Box
          onClick={() => onInvoiceOpen(params.row.invoice)}
          sx={{
            ...(!params.row.invoice ? theme.customStyles.disabled : ""),
            display: "flex",
            alignItems: "center",
            height: "100%",
            cursor: "pointer",
          }}
        >
          <DownloadForOfflineOutlinedIcon />
        </Box>
      ),
      flex: 1,
    },
  ];
  return (
    <StyledSettingsScreen
      sx={{
        ...(isLoading ? theme.customStyles.disabled : {}),
        position: "relative",
      }}
    >
      <CustomTable
        localeText={DataGridText.NO_BILLINGS}
        tableRows={tableRows || []}
        tableColumns={tableColumns}
        totalRowNumber={tableRows?.length || 0}
        title={SettingsPageText.BILLING}
      />

      {isLoading && (
        <CircularProgress
          sx={{ position: "absolute", left: "50%", top: "50%" }}
        />
      )}
    </StyledSettingsScreen>
  );
};

export default BillingScreen;
